
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";

const AdminHeader = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { toast } = useToast();
  
  // Handle navigation with a consistent pattern
  const handleNavigation = (path: string) => {
    // Store current path before navigation
    localStorage.setItem("previousPath", window.location.pathname);
    navigate(path);
  };
  
  // Use the auth context logout method which properly handles Supabase signOut
  const handleLogout = async () => {
    try {
      await logout();
      // The logout function in useAuth already handles navigation and toast
    } catch (error) {
      console.error("Logout error:", error);
      toast({
        title: "Error",
        description: "Failed to log out. Please try again.",
        variant: "destructive",
      });
    }
  };
  
  return (
    <header className="bg-emu-blue text-white py-4 md:py-6 shadow-md w-full">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <h1 className="text-xl md:text-2xl font-bold">Admin Dashboard</h1>
          
          <div className="hidden md:flex items-center space-x-2">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-emu-blue/80 text-lg font-medium"
              onClick={() => handleNavigation("/profile")}
            >
              <User className="mr-2 h-5 w-5" />
              Profile
            </Button>
            <Button 
              className="bg-white text-emu-blue hover:bg-gray-100 font-medium px-4 py-1 rounded shadow-sm"
              onClick={handleLogout}
            >
              Log Out
            </Button>
          </div>
          
          <div className="md:hidden flex items-center space-x-2">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-emu-blue/80"
              onClick={() => handleNavigation("/profile")}
            >
              <User className="h-5 w-5" />
            </Button>
            <Button 
              className="bg-white text-emu-blue hover:bg-gray-100 font-medium px-3 py-1 rounded shadow-sm text-sm"
              onClick={handleLogout}
            >
              Log Out
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
